<template>
  <button
    class="offer-type-button font-16 tbc-medium flex-center lh-24"
    :class="{ active: active }"
    @click="$emit('click', $event)"
  >
    {{ title }}
    <span class="">
      <svg
        v-if="tagId"
        xmlns="http://www.w3.org/2000/svg"
        width="16.97"
        height="16.97"
        viewBox="0 0 16.97 16.97"
      >
        <path
          id="Combined_Shape"
          data-name="Combined Shape"
          d="M5,11V7H1A1,1,0,0,1,1,5H5V1A1,1,0,0,1,7,1V5h4a1,1,0,0,1,0,2H7v4a1,1,0,0,1-2,0Z"
          transform="translate(8.485 16.97) rotate(-135)"
          fill="#fff"
        />
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    tagId: {
      type: [String, Number]
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.offer-type-button {
  background: #24313d;
  padding: 12px;
  height: 32px;
  color: #dadada;
  /*border-radius: 1px solid #d9d9d9;*/
  /* margin-bottom: 10px; */
  /*margin-right: 10px;*/
  border-radius: 4px;
  text-transform: capitalize;
  line-height: unset;
  transition: 0.6s;
}
body[data-theme="night"] .offer-type-button {
  background: #333333;
  color: #dadada;
  border: 1px solid transparent;
}
.offer-type-button.active,
body[data-theme="night"] .offer-type-button.active {
  background-color: var(--tbc-blue);
  color: #ffffff;
  transition: 0.6s ease;
}
.offer-type-button.active {
  background-color: var(--tbc-blue);
  color: #ffffff;
  transition: background-color 0.6s ease, color 0.2s ease;
}
.offerTypeSwiper .siper-slide:first-child span svg {
  display: none;
}
.offer-type-button span svg {
  width: 16px;
  height: 17px;
}
.offer-type-button.active span {
  transform: scale(1, 1);
  margin-left: 6px;
  width: auto;
  transition: 0.2s;
}
.offer-type-button span {
  transform: scale(0, 0);
  display: flex;
  align-items: center;
  width: 0;
  transition: 0.2s;
}
</style>
